import http from "../helpers/http-common"

class LikesDataService {

    getList(params) {
        return http.post(`/likes/list`, params)
    }

    search(params) {
        return http.post(`/likes/search`, params)
    }

    getStats(params) {
        return http.post(`/likes/stats`, params)
    }

    history(userId, params) {
        return http.post(`/likes/history/${userId}`, params)
    }

    getCensoredVideoLikes(params) {
        return http.post('/likes/censoredVideoLikes', params);
    }
}

export default new LikesDataService();